import { TAccount } from '@helpers/Accounts/accounts.types';
import { getDurationInMonths } from '@helpers/GetDurationInMonths/getDurationInMonths';

type TUseGetAccountCardData = {
    loanStatus: TAccount['loan_status'];
    outstandingBalance: NonNullable<TAccount['pending_balance']>['total'];
    durationInMonths: ReturnType<typeof getDurationInMonths>;
    interest: number;
    productType: TAccount['product_type'];
};
export const useGetAccountCardData = (
    account: TAccount
): TUseGetAccountCardData => {
    return {
        loanStatus: account.loan_status,
        outstandingBalance: account.pending_balance?.total,
        durationInMonths: getDurationInMonths(account.duration!),
        interest: account.interest_rates?.[0].rate || 0,
        productType: account.product_type
    };
};
